import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "w-full py-3 px-7" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("li", null, " Backstage or live apperances only; No match promo videos of pre-show panel guests. ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("li", null, " No authority figures, trainers, referees or announcers. Managers/valets on scorecard do not count. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("li", null, "Any picks highlighted red are scheduled", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" You get ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" picks ")
const _hoisted_8 = {
  key: 1,
  class: "flex flex-col gap-y-2"
}
const _hoisted_9 = {
  key: 2,
  class: "flex flex-col gap-y-2"
}
const _hoisted_10 = /*#__PURE__*/_createTextVNode("+")

import ScorecardSection from './ScorecardSection.vue';
import { computed, inject, onMounted, PropType, ref, toRefs } from 'vue';
import PotentialScore from './PotentialScore.vue';
import { useWrestlerStore } from '@/store/wrestlers';
import { useScorecardStore } from '@/store/scorecards';
import { ScorecardDisplayState } from '@/typings/scorecard';
import { cloneDeep } from 'lodash';
import Dropdown from '../Inputs/Dropdown.vue';
import { useValidation } from '@/composable/useValidation';


export default /*#__PURE__*/_defineComponent({
  props: {
  unscheduledCount: {
    type: Number,
    required: true,
  },
  response: {
    type: Array as PropType<Array<string | number>>,
    required: true,
  },
  correctResponse: {
    type: Array as PropType<Array<string | number>>,
    required: true,
  },
  disabled: {
    type: Boolean,
  },
},
  setup(__props) {

const props = __props

const { scorecard } = toRefs(useScorecardStore());

const store = useWrestlerStore();
const { wrestlerSearchOptions } = toRefs(store);



const { response, correctResponse } = toRefs(props);

const answer = ref(response?.value || []);

const correctAnswers = computed(() => {
  if (correctResponse.value) {
    return correctResponse.value.map((c) => {
      return wrestlerStore.wrestlers.find(
        (w) => w.SuperstarId == c || w.Name === c
      )?.SuperstarId;
    });
  }
  return [];
});

const wrestlerStore = useWrestlerStore();
const scorecardStore = useScorecardStore();

function getScore(index: number) {
  const score = checkAnswer(answer.value[index]);
  if (score === 0) {
    return '';
  }
  return `+${score}`;
}

function isValidResponse(index: number) {
  if (!answer.value[index]) return true;
  if (scorecard?.value) {
    const allButIndex = cloneDeep(answer.value);
    allButIndex.splice(index, 1);
    return (
      !scorecard.value.event.Scheduled.includes(answer.value[index]) &&
      !allButIndex.includes(answer.value[index])
    );
  }
  return true;
}

function checkAnswer(guess: string | number) {
  if (
    scorecardStore.displayState === ScorecardDisplayState.Editable ||
    resultsMode
  ) {
    return '';
  }
  return isAnswerCorrect(guess);
}
function isAnswerCorrect(guess: string | number) {
  if (
    scorecardStore.displayState === ScorecardDisplayState.Editable ||
    resultsMode
  ) {
    return 0;
  }
  let guessToCheck = guess;
  const wrestler = wrestlerStore.wrestlers.find(
    (w) => w.SuperstarId === guess || w.Name === guess
  );
  if (wrestler) guessToCheck = wrestler.SuperstarId;
  if (correctAnswers.value.includes(parseInt(guessToCheck.toString(), 10))) {
    return scorecardStore.scorecard?.event.UnscheduledPointValue || 0;
  }
  return 0;
}

const status = computed(() => {
  if (
    scorecardStore.displayState === ScorecardDisplayState.Editable ||
    resultsMode
  ) {
    return '';
  }

  if (scorecardStore.displayState === ScorecardDisplayState.View) {
    return answer.value
      .reduce(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        (total: number, guess: string | number, _index: number) =>
          total + isAnswerCorrect(guess),
        0
      )
      .toString();
  }
  if (answer.value.filter((a) => a !== null).length === 0) {
    return 'Not Started';
  }
  if (answer.value.some((a) => a === null || !a.toString().trim().length)) {
    return 'In Progress';
  }
  return 'Complete';
});

const resultsMode = inject('resultsMode');

function add() {
  answer.value.push('');
}

const { isPositiveNumber } = useValidation();

onMounted(() => {
  for (let i = 0; i < response.value.length; i += 1) {
    const entry = response.value[i];
    if (isPositiveNumber(entry)) {
      response.value[i] = parseInt(entry.toString(), 10);
    } else {
      const wrester = store.wrestlers.find((w) => w.Name === entry);
      if (wrester) {
        response.value[i] = wrester.SuperstarId;
      }
    }
  }
});

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createBlock(ScorecardSection, {
    title: "Unscheduled Appearances",
    status: _unref(status)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_unref(resultsMode))
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              _hoisted_3,
              _hoisted_4,
              _hoisted_5,
              _createElementVNode("li", null, [
                _hoisted_6,
                _createElementVNode("b", null, _toDisplayString(__props.unscheduledCount), 1),
                _hoisted_7
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(resultsMode))
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.unscheduledCount, (n) => {
                return (_openBlock(), _createBlock(Dropdown, {
                  key: n,
                  modelValue: answer.value[n - 1],
                  "onUpdate:modelValue": ($event: any) => ((answer.value[n - 1]) = $event),
                  items: _unref(wrestlerSearchOptions),
                  disabled: __props.disabled,
                  type: "allWrestlers",
                  class: _normalizeClass({
            'bg-red-400': !isValidResponse(n - 1),
          }),
                  status: getScore(n - 1)
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "class", "status"]))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(answer.value.length, (n) => {
                return (_openBlock(), _createBlock(Dropdown, {
                  key: n,
                  type: "allWrestlers",
                  modelValue: answer.value[n - 1],
                  "onUpdate:modelValue": ($event: any) => ((answer.value[n - 1]) = $event),
                  items: _unref(wrestlerSearchOptions),
                  disabled: __props.disabled,
                  class: _normalizeClass({
            'bg-red-400': !isValidResponse(n - 1),
          }),
                  status: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled", "class"]))
              }), 128)),
              _createVNode(_component_Button, { onClick: add }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ]))
      ]),
      (_unref(scorecard))
        ? (_openBlock(), _createBlock(PotentialScore, {
            key: 0,
            score: _unref(scorecard).event.UnscheduledPointValue * __props.unscheduledCount
          }, null, 8, ["score"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["status"]))
}
}

})